import { computed, inject, Injectable, signal } from '@angular/core';
import { User } from '@shared/models/user';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { tap } from 'rxjs/operators';
import { shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public readonly fetchUser$ =  inject(HttpClient)
    .get<User>(`${environment.apiGatewayUrl}/distribution-center/user/me`)
    .pipe(
      shareReplay({ bufferSize: 1, refCount: true }),
      tap(user => this.currentUser.set(user)));

  public readonly isCsUser = computed(() => this.currentUser()?.userType === 'CS');
  public readonly isDcUser = computed(() => this.currentUser()?.userType === 'DC');
  private readonly currentUser = signal<User | null>(null);
}
